module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 140.7c064843.png";